import { WeeklyValue } from 'types'

export const sortByWeek: <D extends WeeklyValue>(data: D[]) => D[] = (data) =>
  [...data].sort((d1, d2) => {
    return `${d1.year}-${`0${d1.week}`.slice(-2)}`.localeCompare(`${d2.year}-${`0${d2.week}`.slice(-2)}`)
  })
